/**
 * QuotaExceededModal — hard-stop dialog shown when a request is refused with
 * HTTP 402 `quota_exceeded`. Upgrade CTAs match Rails shared/_quota_ctas.
 */

import { h } from 'preact'
import { useCallback } from 'preact/hooks'
import { useBootstrapModal } from '../../../modules/drive/bootstrap-modal.js'
import { normalizeQuota } from './parseQuotaError.js'
import { t as defaultT, metricLabel } from './quota-i18n.js'
import { QuotaMeter } from './QuotaMeter.jsx'
import { QuotaCtas } from './QuotaCtas.jsx'

export function QuotaExceededModal({ open, quota, t = defaultT, format, onClose }) {
  const handleHidden = useCallback(() => onClose?.(), [onClose])
  const modalRef = useBootstrapModal(!!open && !!quota, handleHidden)
  const data = normalizeQuota(quota)

  const label = data ? metricLabel(data.metric, t) : ''
  const upgrades = data?.upgrades ?? []

  return (
    <div class="modal fade" tabindex="-1" aria-hidden="true" ref={modalRef}>
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="bi bi-speedometer2 me-2" />
              {t('quotas.exceeded_title')}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label={t('quotas.dismiss')} />
          </div>
          <div class="modal-body">
            {data && (
              <>
                <p class="mb-3">{t('quotas.exceeded_body', { metric: label })}</p>
                <QuotaMeter quota={data} t={t} format={format} className="mb-3" />
                {data.recorded === true && (
                  <p class="small text-muted">{t('quotas.recorded_note')}</p>
                )}
                {upgrades.length === 0 && (
                  <p class="text-muted mb-3">{t('quotas.soft_lock_help')}</p>
                )}
                <QuotaCtas upgrades={upgrades} t={t} variant="danger" size="" />
              </>
            )}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{t('quotas.dismiss')}</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default QuotaExceededModal
